import { render, staticRenderFns } from "./转出项目商品详细_默认版本.vue?vue&type=template&id=a1a7d79e&scoped=true"
import script from "./转出项目商品详细_默认版本.vue?vue&type=script&lang=js"
export * from "./转出项目商品详细_默认版本.vue?vue&type=script&lang=js"
import style0 from "./转出项目商品详细_默认版本.vue?vue&type=style&index=0&id=a1a7d79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a7d79e",
  null
  
)

export default component.exports